import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import edgeConnectionsState from './state';
export const edgeConnectionsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => edgeConnectionsState);
    },
    initialState: edgeConnectionsState,
    name: 'edgeConnections',
    reducers: {
        errorReceiveCreateEdgeConnection: state => {
            state.requestingCreateEdgeConnection = false;
        },
        errorReceiveEdgeConnections: state => {
            state.edgeConnections = undefined;
            state.requestingEdgeConnections = false;
        },
        errorReceiveEdgeOfferingConnections: state => {
            state.edgeOfferingConnections = undefined;
            state.requestingEdgeOfferingConnections = false;
        },
        errorReceiveModifyEdgeConnection: state => {
            state.requestingModifyEdgeConnection = false;
        },
        errorReceiveRemoveEdgeConnection: state => {
            state.requestingRemoveEdgeConnection = false;
        },
        failedReceiveCreateEdgeConnection: state => {
            state.requestingCreateEdgeConnection = false;
        },
        failedReceiveEdgeConnections: state => {
            state.edgeConnections = undefined;
            state.requestingEdgeConnections = false;
        },
        failedReceiveEdgeOfferingConnections: state => {
            state.edgeOfferingConnections = undefined;
            state.requestingEdgeOfferingConnections = false;
        },
        failedReceiveModifyEdgeConnection: state => {
            state.requestingModifyEdgeConnection = false;
        },
        failedReceiveRemoveEdgeConnection: state => {
            state.requestingRemoveEdgeConnection = false;
        },
        receiveCreateEdgeConnection: {
            prepare: edgeConnection => {
                return {
                    payload: {
                        edgeConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeConnection } = action.payload;
                state.edgeConnections = state.edgeConnections ? [...state.edgeConnections, edgeConnection] : [edgeConnection];
                state.requestingCreateEdgeConnection = false;
            }
        },
        receiveEdgeConnections: {
            prepare: edgeConnections => {
                return {
                    payload: {
                        edgeConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeConnections } = action.payload;
                state.edgeConnections = edgeConnections;
                state.requestingEdgeConnections = false;
            }
        },
        receiveEdgeOfferingConnections: {
            prepare: edgeConnections => {
                return {
                    payload: {
                        edgeConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeConnections } = action.payload;
                state.edgeOfferingConnections = edgeConnections;
                state.requestingEdgeOfferingConnections = false;
            }
        },
        receiveModifyEdgeConnection: {
            prepare: edgeConnection => {
                return {
                    payload: {
                        edgeConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeConnection } = action.payload;
                state.edgeConnections = state.edgeConnections.map(connection => connection.id === edgeConnection.id ? edgeConnection : connection);
                state.requestingModifyEdgeConnection = false;
            }
        },
        receiveRemoveEdgeConnection: {
            prepare: edgeConnectionId => {
                return {
                    payload: {
                        edgeConnectionId
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeConnectionId } = action.payload;
                state.edgeConnections = state.edgeConnections.filter(connection => connection.id !== edgeConnectionId);
                state.requestingRemoveEdgeConnection = false;
            }
        },
        requestCreateEdgeConnection: {
            prepare: (edgeOfferingId, edgeConnectionPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeConnectionPayload,
                        edgeOfferingId
                    }
                };
            },
            reducer: state => {
                state.requestingCreateEdgeConnection = true;
            }
        },
        requestEdgeConnections: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingEdgeConnections = true;
            }
        },
        requestEdgeOfferingConnections: {
            prepare: (targetOrganization, edgeOfferingId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeOfferingId,
                        targetOrganization
                    }
                };
            },
            reducer: state => {
                state.requestingEdgeOfferingConnections = true;
            }
        },
        requestModifyEdgeConnection: {
            prepare: (edgeConnectionId, edgeConnectionPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeConnectionId,
                        edgeConnectionPayload
                    }
                };
            },
            reducer: state => {
                state.requestingModifyEdgeConnection = true;
            }
        },
        requestRemoveEdgeConnection: {
            prepare: (edgeConnectionId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        edgeConnectionId
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveEdgeConnection = true;
            }
        },
        resetEdgeConnections: () => edgeConnectionsState
    }
});
export const { errorReceiveCreateEdgeConnection, errorReceiveEdgeConnections, errorReceiveEdgeOfferingConnections, errorReceiveModifyEdgeConnection, errorReceiveRemoveEdgeConnection, failedReceiveCreateEdgeConnection, failedReceiveEdgeConnections, failedReceiveEdgeOfferingConnections, failedReceiveModifyEdgeConnection, failedReceiveRemoveEdgeConnection, receiveCreateEdgeConnection, receiveEdgeConnections, receiveEdgeOfferingConnections, receiveModifyEdgeConnection, receiveRemoveEdgeConnection, requestCreateEdgeConnection, requestEdgeConnections, requestEdgeOfferingConnections, requestModifyEdgeConnection, requestRemoveEdgeConnection, resetEdgeConnections } = edgeConnectionsSlice.actions;
export default edgeConnectionsSlice.reducer;
